import script from "./SortDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SortDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SortDropdown.vue?vue&type=style&index=0&id=5811fe98&scoped=true&lang=css"
import "./SortDropdown.vue?vue&type=style&index=1&id=5811fe98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5811fe98"]])

export default __exports__